import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import i18n from './i18n/index.js'
import router from './router/router'
import App from './App.vue'
import VueCookie from 'vue-cookie'
import toastr from 'toastr'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/main.css'
import 'toastr/toastr.scss'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueCookie)

toastr.options = {
  'debug': false,
  "positionClass": "toast-bottom-right",
  'progressBar': true
}
Vue.prototype.$toasted = toastr

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
